import { render, staticRenderFns } from "./afrAddressDialog.vue?vue&type=template&id=31aca344&"
import script from "./afrAddressDialog.vue?vue&type=script&lang=js&"
export * from "./afrAddressDialog.vue?vue&type=script&lang=js&"
import style0 from "./afrAddressDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31aca344')) {
      api.createRecord('31aca344', component.options)
    } else {
      api.reload('31aca344', component.options)
    }
    module.hot.accept("./afrAddressDialog.vue?vue&type=template&id=31aca344&", function () {
      api.rerender('31aca344', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Job/afrAddressDialog.vue"
export default component.exports